import { NgModule } from '@angular/core';
import { BodyGenerateOrderComponent } from './body-generate-order.component';
import { CommonModule } from '@angular/common';
import { DetailsModule } from 'src/app/components/details/details/details.module';
import { FormOrderModule } from 'src/app/components/form/form-order/form.module';
import { FormOrderFromBoardModule } from 'src/app/components/form/form-order-from-board/form.module';
import { CommissionSvgModule } from 'src/app/shared/styles/svg/commission/commission.module';
import { DuplicateOrderSvgModule } from 'src/app/shared/styles/svg/duplicate-order/duplicate-order.module';
import { CommissionModule } from 'src/app/components/cards/commission/commission.module';
import { DuplicateOrdersModule } from 'src/app/components/cards/duplicate-orders/duplicate-orders.module';

@NgModule({
  declarations: [
    BodyGenerateOrderComponent
  ],
  imports: [
    CommonModule,
    FormOrderModule,
    FormOrderFromBoardModule,
    DetailsModule,
    
    CommissionSvgModule,
    DuplicateOrderSvgModule,
    CommissionModule,
    DuplicateOrdersModule
  ], exports: [
    BodyGenerateOrderComponent
  ]
})
export class BodyGenerateOrderModule { }
